/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsNetworkWired: {
  name: 'network-wired';
  data: string;
} = {
  name: 'network-wired',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-4Zm0 2h4v3h-4V4Zm5 11a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-4Zm0 2h4v3h-4v-3ZM3 17a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3Zm6 0H5v3h4v-3Zm-6-6a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z" fill="currentColor"/></svg>`,
};
